import { createActions, createReducer } from 'reduxsauce'

import ReferenciaService from '../servicos/ReferenciaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaReferenciaInicio: [],
    buscaReferenciaSucesso: ['referencia'],
    buscaReferenciaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaReferencia = () => {
    return dispatch => {
        dispatch(Creators.buscaReferenciaInicio())
        let serv = new ReferenciaService()
        return serv
            .getReferencia()
            .then(response => dispatch(Creators.buscaReferenciaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaReferenciaErro(error)))
    }
}

const buscaReferenciaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaReferenciaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })
const buscaReferenciaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.referencia, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_REFERENCIA_INICIO]: buscaReferenciaInicio,
    [Types.BUSCA_REFERENCIA_ERRO]: buscaReferenciaErro,
    [Types.BUSCA_REFERENCIA_SUCESSO]: buscaReferenciaSucesso,
})
